import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import dashboardImg_1 from 'Images/public/datasubmission/Dashboard_image_1.svg';
import dashboardImg_2 from 'Images/public/datasubmission/Dashboard_image_2.svg';
import dashboardImg_3 from 'Images/public/datasubmission/Dashboard_image_3.svg';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { ICONS } from 'Utils/icons';
import { IconTextButton, TextButton } from 'Components/Button';
import { NumberedSteps } from 'Components/Public/NumberedSteps/NumberedSteps';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { FloatingCallToAction } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
import { DidFindPrompt } from 'Components/Public/DidFindPrompt/DidFindPrompt';
import { NextPage } from 'Components/Public/NextPage/NextPage';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import { handleFileDownload, isLoggedIn, openInNewTab } from 'Utils/utilityFunctions';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";
import {Link} from "react-router-dom";
import DownloadLink from "../../../Components/Public/DownloadLink/DownloadLink";
import {getDocumentDownloadCall} from "../../../Utils/utilityFunctions";

//DOWNLOAD
function DataSubmission () {
  
    const navigate = useNavigate();
    const SFTPDataSubmissionManualGroupId = 153;
    const PSOPPCWebServiceManualGroupId = 154;
    const IssuePSOSpecificClinicalDashboardsGroupId = 1762;
    const IssueComparativeNationalDashboard = 2471;
    const EB23GroupId = 138;
    const EB24GroupId = 139;
    const CDAR2XMLGroupId = 2042;
    const CFERImplementationGroupId = 2630;
    const CFERFIleSamplesGroupId = 2601;
    const EB36GroupId = 744;
    const CFERAltFormatGroupId = 2634;
    const CFERAltUsersGuideGroupId = 2632;
    const CFERAltFileSamplesGroupId = 2633;
    const step4Text =
        <>
            <p>
                After protecting and mapping your data, select the submission method that best fits your workflow. The PSOPPC supports multiple submission options and formats, including manual uploads of Patient Safety Event (PSE) Data CDA XML, XML, or CSV files, as well as automated submissions through a Secure File Transfer Protocol (SFTP) connection.
            </p>
            <p>
                Use the resources below to understand each option, review technical requirements, and access detailed instructions for submitting patient safety data.
            </p>
        </>;
    return (
        <>
            <ReCaptchaWrapper
              action="submit_data_landing"
              title="Submit Data"
            >
                <Row className="m-0 p-0">
    
                    <PageHeader
                        title="Submit Data"
                        intro="By securely sharing your PSO's patient safety data with PSOPPC, you contribute to national learning that helps improve the quality of care."
                    >
                        <h2 className="public-title text-center mb-3">Insights from submitted data</h2>
                        <Row className="public-cards col-gap-2 row-gap-3">
                            <Col md={4} lg={4}>
                                <Card className="h-100">
                                    <Card.Body>
                                        <p className="public-card-header">The NPSD Dashboards</p>
                                        <div className="public-card-content align-items-start mb-3">
                                          {/* remove alt text="NPSD Dashboard" for the image, it cause redundant alternative text 508 alert */}
                                            <img alt="" className="mb-2 maxHeight--100 w-100" src={dashboardImg_1} ></img>
                                            <p>Almost three-fourths of incident blood events during 2024 involved red blood cells as the type of blood product.</p>
                                        </div>
                                        <div className="public-card-footer">
                                            <IconTextButton
                                                variant={'clear'}
                                                icon={ICONS.launch}
                                                className="reverse p-0 text-start"
                                                content={'View NPSD Dashboards'}
                                                onClick={() =>
                                                    openInNewTab('https://www.ahrq.gov/npsd/data/dashboard/index.html')
                                                }
                                            ></IconTextButton>
                                           
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4} lg={4}>
                                <Card className="h-100">
                                    <Card.Body>
                                        <p className="public-card-header">Hospital Version 1.2 Clinical Dashboards*</p>
                                        <div className="public-card-content align-items-start mb-3">
                                            <img alt="NPSD Chartbook" className="mb-2 maxHeight--120 w-100" src={dashboardImg_2}></img>
                                            <p>
                                                Incidents of unknown harm dropped from 10.4% in 2020 to 3.2% in 2023.
    
                                            </p>
                                        </div>
                                        
                                        <div className="public-card-footer text-start">
                                            <p className={`public-card-footer-note`}>
                                                *Clinical National Dashboards are available to submitting PSOs. The data above is sample data.
                                            </p>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4} lg={4}>
                                <Card className="h-100">
                                    <Card.Body>
                                        <p className="public-card-header">The NPSD Chartbooks</p>
                                        <div className="public-card-content align-items-start mb-3">
                                            <img alt="PSOPPC Clinical Dashboard" className="mb-2 maxHeight--120 w-100" src={dashboardImg_3}></img>
                                            <p>In 2024, 77.1% of pressure injury events were reported to have pressure injury preventive intervention in place.</p>
                                        </div>
                                        <div className="public-card-footer">
    
                                            <IconTextButton
                                                variant={'clear'}
                                                icon={ICONS.launch}
                                                className="reverse p-0 text-start"
                                                content={'View NPSD Chartbooks'}
                                                onClick={() =>
                                                    openInNewTab('https://www.ahrq.gov/npsd/data/chartbook/index.html')
                                                }
                                            ></IconTextButton>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </PageHeader>
    
    
                    <Row lg={10} className="main-content m-0  mb-4 mt-4   pt-4 pb-4 d-flex  align-items-center flex-column-reverse row-2 flex-lg-row justify-content-center mb-0">
    
                        <Col lg={6} className="m-0 p-0 mt-5 col-11">
                            <div className="step-title d-block d-md-grid m-0 p-2 p-md-0">
                                <h3 className="text-start">
                                    Follow these steps to securely submit your data
                                </h3>
                            </div>
                            <div className="steps">
                                <NumberedSteps
                                    number={'01'}
                                    elementId="step-01"
                                    stepTitle="Sign a Data Use Agreement"
                                    stepText={"Your data is sensitive and valuable. Before you submit any data, our team will send you a DocuSign for an agreement that clearly outlines how your data may be used, how long we may use data, and how data will be protected."}
                                >
                                    <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                        <IconTextButton
                                            variant={'normal'}
                                            icon={ICONS.download}
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            content={'Learn about the DUA'}
                                            groupId={552}
                                            // onClick={() =>
                                            //     handleFileDownload(552)
                                            // }
                                        ></IconTextButton>
                                        <IconTextButton
                                            variant="outline"
                                            icon={ICONS.mailoutlined}
                                            content="Contact us to sign a DUA"
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            href="mailto:support@psoppc.org"
                                        /* onClick={() =>
                                                navigate("")
                                            }*/>
                                        </IconTextButton>
                                    </div>
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'02'}
                                    stepTitle="Protect the data"
                                    stepText={"Our number one priority is protecting the identities of patients, providers, and reporters. When submitting data to PSOPPC, we ask that PSOs assign unique Provider IDs to their member providers so information can’t be tracked back to an individual or facility. Any identifying information found in free-form text fields will never be sent to the NPSD."}
                                >
                                    <TextButton
                                        variant="normal"
                                        content="How we will protect your data"
                                         className="w-xs-100 w-sm-fit-content justify-content-center"
                                        onClick={() =>
                                            navigate(PATHS.public['Data Security'])
                                        }
                                    ></TextButton>
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'03'}
                                    stepTitle="Use Common Formats"
                                    stepText={"To help us compare your data to data from other PSOs, we ask that you map to the Common Formats. Our team stands ready to help you with mapping when you're ready for this step."}
                                >
                                    <TextButton
                                        variant="normal"
                                        content="Learn more about Common Formats"
                                         className="w-xs-100 w-sm-fit-content justify-content-center"
                                        onClick={() =>
                                            navigate(PATHS.public['Current Common Formats'])
                                        }
                                    ></TextButton>
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'04'}
                                    stepTitle="Choose your submission method"
                                    stepText={step4Text}
                                >
                                    <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                        <IconTextButton
                                            variant={'normal'}
                                            icon={ICONS.download}
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            content={'PSE Data Submission Overview'}
                                            groupId={150}
                                            // onClick={() =>
                                            //     handleFileDownload(150)
                                            // }
                                        ></IconTextButton>
                                        <IconTextButton
                                            variant={'outline'}
                                            icon={ICONS.download}
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            content={'SFTP Data Submission User Manual'}
                                            groupId={153}
                                            // onClick={() =>
                                            //     handleFileDownload(153)
                                            // }
                                        ></IconTextButton>
                                        <IconTextButton
                                            variant={'outline'}
                                            icon={ICONS.download}
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            content={'PSOPPC Web Service Users Manual'}
                                            groupId={154}
                                            // onClick={() =>
                                            //     handleFileDownload(154)
                                            // }
                                        ></IconTextButton>
                                        <IconTextButton
                                            variant={'outline'}
                                            icon={ICONS.download}
                                            className="reverse text-center w-100 d-flex justify-content-center"
                                            content={'Patient Safety Data Submission FAQs'}
                                            groupId={151}
                                            // onClick={() =>
                                            //     handleFileDownload(151)
                                            // }
                                        ></IconTextButton>
                                    </div>
                                    
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'05'}
                                    stepTitle="Submit test data"
                                    stepText={"Now you're ready to do a test submission. Try submitting a portion of your data as a test to make sure it clears all the necessary checks. You will get a report with any errors you need to fix."}
                                >
                                    {
                                        isLoggedIn() == true
                                        ?   null
                                        :   <TextButton variant="normal"  className="w-xs-100 w-sm-fit-content justify-content-center" content="Log in to submit test data" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton>
                                    }
                                    
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'06'}
                                    stepTitle="Review feedback"
                                    stepText={"After submitting test data, you'll get a report that details any errors in the file structure or the data itself that you may need to fix before submitting production data to the PSOPPC."}
                                >
                                    {
                                        isLoggedIn() == true
                                        ?   null
                                        :   <TextButton variant="normal" content="Log in to review the reports"  className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton>
                                    }
                                    
                                </NumberedSteps>
                                <NumberedSteps
                                    number={'07'}
                                    stepTitle="Submit all data anytime"
                                    stepText={"Once you've fixed any errors in your test file, feel free to submit as much data as you'd like, as frequently as you'd like to the PSOPPC. Some PSOs choose to submit to us once a week while others submit once a quarter or once a year. Our team will review the data on an ongoing basis and work with the NPSD to publish insights regularly."}
                                >
                                    {
                                        isLoggedIn() == true
                                        ?   null
                                        :   <TextButton variant="normal" content="Log in to submit data"  className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton>
                                    }
                                </NumberedSteps>
                            </div>
                        </Col>
    
    
                        <FloatingCallToAction
                            title="Ready to submit?"
                            text={isLoggedIn() == true ? null : "Login in now to submit data."}
                        >
                            {
                                isLoggedIn() == true
                                ?   <TextButton variant="normal" content="Submit Data" onClick={()=>navigate(PATHS.private.cda)}></TextButton>
                                :   <TextButton variant="normal" content="Log In" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton>
                            }
                        </FloatingCallToAction>
    
                    </Row>
    
                </Row>
            {/*Commented as of UAT Bugfix - Revision of FAQs*/}
            {/*<Row className="faq m-0 d-flex justify-content-center">*/}
            {/*    <Col lg="10">*/}
            {/*        <h2 className="mb-5">Frequently Asked Questions</h2>*/}
            {/*        <PublicAccordion*/}
            {/*            defaultActiveKey={[]}*/}
            {/*            accordionItemsContent={[*/}
            {/*                {*/}
            {/*                    header: "If our reporting system is a 1:1 match with the  AHRQ Common Formats, do you use all data points if we send them to you, or do you only use a certain data set out of all the Common Formats?",*/}
            {/*                    content: "Unless the data is missing a required data field, the data is accepted by the import processor. Some data fields that may be used at the local level, mostly identifiers, are removed by the import processor for privacy protections. Please note that data submission/acceptance rules vary by submission format. For more information on our privacy protection measures, please view Educational Brief 49. The PSOPPC has also compiled a list of common questions associated with the patient safety data submission process which you can view here: Frequently Asked Questions."*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    header: "Do you accept and analyze 100% of the Common Formats or just a certain percentage?",*/}
            {/*                    content: "We do accept data across the Common Formats and their different versions, but not all data is ultimately included for analysis. There are global exclusions for Common Formats for Event Reporting - Hospital V1.2 (see Appendix A). In the case of resubmissions, only the most recent version of a reported event or safety concern is considered in yearly analyses. Also, there are some event types that data are accepted for, but are not included for public-facing analysis as there are not yet sufficient responses to meet non-identification requirements."*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    header: "If it is only a certain percentage, what data points make that percentage up?",*/}
            {/*                    content: "We strive to use as many records as possible! For example, about 98.0% of CFER-H V1.2 data that are submitted and accepted by the import processor are included in initial analyses, but there is variance across event types for data inclusion and publication of analyses. Apart from defined exclusions (see response to question #2), we do not publish analyses of some data elements that are too sparsely populated due to non-identification requirements. However, we encourage PSOs to submit Patient Safety data as more submissions enable more representative and richer analyses to be publicly available."*/}
            {/*                },*/}
            {/*                /* remove this ALT format FAQ - content is not accurate*/}
            {/*                {*/}
            {/*                    header: "For the "Question Group ID" field used to group related questions together within a section, is it a requirement to have more than one group of medications or equipment, or can we use a single group where we default to 1? We only capture a single device or medication per incident.",*/}
            {/*                    content: "It is not a requirement. You are able to submit a single group with the default group ID to "1".  However, the Common Formats do allow for reporting multiple devices or medications where applicable."*/}
            {/*                },*/}
            {/*                */}
            {/*            ]}*/}
            {/*        ></PublicAccordion>*/}
            
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row className="faq m-0 d-flex justify-content-center submit-data-faq">
                <Col lg="10">
                    <h2 className="mb-5">Frequently Asked Questions</h2>
                    <h3 className={"mt-5 mb-3 dark-blue header3"}>Preparing for Submission</h3>
                    <PublicAccordion
                      defaultActiveKey={[]}
                      accordionItemsContent={[
                          {
                              header: "My PSO is collecting Patient Safety Event Data and is ready to provide these data to the PSOPPC. What steps do I need to take to prepare for data submission?",
                              content: () => {
                                  return (
                                    <>
                                      <p className="mb-2">If your Patient Safety Organization (PSO) is preparing to submit Patient Safety Event data to the PSOPPC (Patient Safety Organization Privacy Protection Center), here are the key steps to ensure you’re ready for submission:</p>
                                      <p className="mb-1 font-weight-bold">Step 1: Verify Administrative Prerequisites</p>
                                      <ul className="mb-1">
                                          <li>Signed Data Use Agreement (DUA): Ensure your PSO has a fully executed DUA on file with the PSOPPC.</li>
                                          <li>Level 3 User Account: Request a PSOPPC User Account with Level 3 authorization (required for data submission)</li>
                                          <li>Vendor Authorization: If you use a third-party software vendor, ensure they are properly registered and authorized to submit on your behalf, if applicable.</li>
                                      </ul>
                                      <p className="mb-1 font-weight-bold">Step 2: Technical Strategy & Review</p>
                                      <ul className="mb-1">
                                        <li>Review Common Formats Technical Specifications to decide:</li>
                                        <ul className="mb-1">
                                          <li>Common Format Version: Which specific version your organization will submit.</li>
                                          <li>Data Submission Method: Decide which format best fits your organization’s needs:</li>
                                          <ul className="mb-1">
                                            <li>HL7 CDA XML: The traditional clinical architecture standard.</li>
                                            <li>PSOPPC-compliant XML/DSV: Simpler formats supported via the Alternate Data Submission process.</li>
                                          </ul>
                                        </ul>
                                      </ul>
                                      <p className="mb-1 font-weight-bold">Step 3: Data Mapping & De-identification</p>
                                      <ul className="mb-1">
                                        <li>Align Fields: Map your internal data fields to the latest AHRQ Common Formats Data Elements</li>
                                        <li>Validation: Ensure all required elements are captured and that your data matches the accepted value domains (the specific valid answer for each data element)</li>
                                        <li>Identity Protection: Remove all prohibited identifiers. You must use the PSO-assigned Pseudo ID in the Provider ID data element to ensure anonymity.</li>
                                      </ul>
                                      <p className="mb-1 font-weight-bold">Step 4: File Generation & Testing</p>
                                      <ul className="mb-1">
                                        <li>Generate your report files in one of the accepted formats:</li>
                                        <ul className="mb-1">
                                          <li>HL7 CDA XML format</li>
                                          <li>PSOPPC-compliant XML format</li>
                                          <li>PSOPPC-compliant DSV format</li>
                                        </ul>
                                        <li>Submit your files as Test Submissions through the secure portal.</li>
                                        <li>Review the Feedback Report and address any rejected records or validation errors.</li>
                                      </ul>
                                      <p className="mb-1 font-weight-bold">Step 5: Production Submission</p>
                                      <ul className="mb-1">
                                        <li>Once your test files are processed without errors, you can establish your ongoing submission process for production data through Production Submissions.</li>
                                      </ul>
                                    </>
                                  )
                              }
                          },
                          {
                              header: "Which Common Formats version should my organization submit - Hospital 1.2 or Hospital 2.0?",
                              content: () => {
                                  return (
                                    <>
                                      <p className={"mb-2"}>
                                        <strong>Both CFER-Hospital Version 1.2 and Version 2.0 are currently active and available for reporting.</strong> The choice depends on your organization’s technical readiness and reporting goals.
                                      </p>
                                      <p className="mb-2">
                                        Version 2.0 represents a major update to the AHRQ Common Formats for hospitals. It enhances and clarifies event descriptions while streamlining the data structure by reducing and consolidating data elements. These improvements are intended to simplify data collection and make it easier for PSOs to prepare and submit standardized reports.
                                      </p>
                                      <p className="mb-0">
                                        Here are the key differences comparing the two versions: 
                                      </p>
                                      <div className="table-wrapper mt-0 mb-0">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <th>Feature</th>
                                              <th>Hospital 1.2</th>
                                              <th>Hospital 2.0</th>
                                            </tr>
                                            <tr>
                                              <td>Release</td>
                                              <td>2012-04</td>
                                              <td>2017-05</td>
                                            </tr>
                                            <tr>
                                              <td>Event Types</td>
                                              <td>
                                                <p className={'m-0 p-0'}>Blood</p>
                                                <p className={'m-0 p-0'}>Device, including HIT</p>
                                                <p className={'m-0 p-0'}>Fall</p>
                                                <p className={'m-0 p-0'}>Medication</p>
                                                <p className={'m-0 p-0'}>Perinatal</p>
                                                <p className={'m-0 p-0'}>Pressure Ulcer</p>
                                                <p className={'m-0 p-0'}>Surgery or Anesthesia</p>
                                                <p></p>
                                                <p className={'m-0 p-0'}>Venous Thromboembolism</p>
                                                <p className={'m-0 p-0'}>Other</p>
                                                <p className={'m-0 p-0'}>Healthcare-associated Infection</p>
                                              </td>
                                              <td>
                                                <p className={'m-0 p-0'}>Blood</p>
                                                <p className={'m-0 p-0'}>Device</p>
                                                <p className={'m-0 p-0'}>Fall</p>
                                                <p className={'m-0 p-0'}>Medication</p>
                                                <p className={'m-0 p-0'}>Perinatal</p>
                                                <p className={'m-0 p-0'}>Pressure Injury</p>
                                                <p className={'m-0 p-0'}>Surgery</p>
                                                <p className={'m-0 p-0'}>Anesthesia</p>
                                                <p className={'m-0 p-0'}>Venous Thromboembolism</p>
                                                <p className={'m-0 p-0'}>Other</p>
                                                <p></p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Number of Data Elements to Submit</td>
                                              <td>197</td>
                                              <td>89</td>
                                            </tr>
                                            <tr>
                                              <td>Accept Partial Dataset</td>
                                              <td>Yes</td>
                                              <td>No</td>
                                            </tr>
                                            <tr>
                                              <td>Support Data Format</td>
                                              <td>
                                                <p className={'m-0 p-0'}>HL7 CDA XML,</p>
                                                <p className={'m-0 p-0'}>PSOPPC-compliant XML/DSV</p>
                                              </td>
                                              <td>
                                                <p className={'m-0 p-0'}>HL7 CDA XML,</p>
                                                <p className={'m-0 p-0'}>PSOPPC-compliant XML/DSV</p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Data Structure</td>
                                              <td>Highly granular, module-specific questions</td>
                                              <td>Streamlined and consolidated data elements</td>
                                            </tr>
                                            <tr>
                                              <td>Reporting Burden</td>
                                              <td>Higher volume of required fields</td>
                                              <td>Reduced number of data elements</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <p className="mt-0">
                                        While the PSOPPC continues to support Version 1.2 for organizations with established legacy workflows, we recommend that organizations beginning a new implementation choose Version 2.0 to benefit from the reduced reporting burden and modernized data standards.
                                      </p>
                                    </>
                                  )
                              }
                          },
                          {
                              header: "What is the difference between Clinical Document Architecture (CDA) XML and PSOPPC-compliant Alternate Data Format? ",
                              content: () => {
                                  return (
                                    <>
                                      <p className="mb-2">The main difference lies in the technical structure of the files and the level of development required. PSOs can choose the method that best aligns with their internal IT capabilities.</p>
                                      <p className="mb-1 font-weight-bold">CDA XML:</p>
                                      <p className="mb-1">This method requires your PSO or software vendor to create report files specifically tailored to the HL7 CDA Release 2.0 Standard. This is a more complex approach that requires developers to have a working knowledge of the HL7 CDA.</p>
                                      <p className="mb-1 font-weight-bold">Technical Resources for CDA XML Submission:</p>
                                      <ul className="mb-2">
                                        <li>
                                            <TextButton 
                                                variant={"comp-link"} 
                                                groupId={EB23GroupId} 
                                                size={"inherit"} 
                                                className="text-start" 
                                                content={"EB 23 - Understanding HL7 CDA (PDF)"} 
                                                // onClick={() => handleFileDownload(EB23GroupId)}
                                            ></TextButton>
                                        </li>
                                        <li>
                                            <TextButton groupId={EB24GroupId} variant={"comp-link"} size={"inherit"} className="text-start" content={"EB 24 - Information for CDA XML Data Submission (PDF)"}     
                                            // onClick={() => handleFileDownload(EB24GroupId)}
                                            ></TextButton>
                                        </li>
                                        <li>
                                            <TextButton groupId={CDAR2XMLGroupId} variant={"comp-link"} size={"inherit"} className="text-start" content={"CDA R2 XML Schema Definition (ZIP)"} 
                                            // onClick={() => handleFileDownload(CDAR2XMLGroupId)}
                                            ></TextButton>
                                        </li>
                                        <li>
                                            <TextButton groupId={CFERImplementationGroupId} variant={"comp-link"} size={"inherit"} className="text-start" content={"CFER-H V2.0aR Implementation Guide (PDF)"} 
                                            // onClick={() => handleFileDownload(CFERImplementationGroupId)}
                                            ></TextButton>
                                        </li>
                                        <li>
                                            <TextButton groupId={CFERFIleSamplesGroupId} variant={"comp-link"} size={"inherit"} className="text-start" content={"CFER-H V2.0aR CDA XML File Samples (ZIP)"} 
                                            // onClick={() => handleFileDownload(CFERFIleSamplesGroupId)}
                                            ></TextButton>
                                        </li>
                                      </ul>
                                      <p className="mb-1 font-weight-bold">Alternate Data Format:</p>
                                      <p className="mb-1">This format serves as a flexible alternative to the CDA requirement. It allows PSOs to submit patient safety reports using either Extensible Markup Language (XML) or Delimiter-Separated Values (DSV) files. The PSOPPC system then handles the conversion into the required architecture.</p>
                                      <p className="mb-1 font-weight-bold">Technical Resources for Alternate Data Submission:</p>
                                      <ul className="mb-1">
                                        <li><TextButton variant={"comp-link"} size={"inherit"} className="text-start" content={"EB 36 - PSOPPC Alternate Data Submission (PDF)"} 
                                        groupId={EB36GroupId}
                                        // onClick={() => handleFileDownload(EB36GroupId)}
                                        ></TextButton></li>
                                        <li><TextButton variant={"comp-link"} size={"inherit"} className="text-start" content={"CFER-H V2.0aR Alternate Format XML Schema Definition (ZIP)"} groupId={CFERAltFormatGroupId}
                                        // onClick={() => handleFileDownload(CFERAltFormatGroupId)}
                                        ></TextButton></li>
                                        <li><TextButton variant={"comp-link"} size={"inherit"} className="text-start" content={"CFER-H V2.0aR Alternate Data Submission Users Guide (PDF)"} groupId={CFERAltUsersGuideGroupId} 
                                        // onClick={() => handleFileDownload(CFERAltUsersGuideGroupId)}
                                        ></TextButton></li>
                                        <li><TextButton variant={"comp-link"} size={"inherit"} className="text-start" content={"CFER-H V2.0aR Alternate Data Submission File Samples (ZIP)"} groupId={CFERAltFileSamplesGroupId}
                                        // onClick={() => handleFileDownload(CFERAltFileSamplesGroupId)}
                                        ></TextButton></li>
                                      </ul>
                                    </>
                                  )
                              }
                          },
                        {
                          header: "What documents are included in the Technical Specifications for Common Formats, and how do they support data submission? ",
                          content: () => {
                            return (
                              <>
                                <p className="mb-2">The Technical Specifications provide the essential framework for formatting, structuring, and validating your data before it is submitted to the PSOPPC. These documents ensure that your patient safety reports are standardized and accurate.</p>
                                <p className="mb-2">You can download all the specifications on the <Link to={PATHS.public['Current Common Formats']} >Current Common Formats</Link> page.</p>
                                <p className="mb-1 font-weight-bold">Core Guidance Documents</p>
                                <p className="mb-1">These resources are required for all submitters to understand the logic and rules of the Common Formats:</p>
                                <ul className="mb-2">
                                  <li>Resources Workbook – provides a complete mapping of OIDs (Object Identifiers), templates, data elements, answer values, and validation rules required to create a submission file.</li>
                                  <li>Data Dictionary – serves as a reference for every data element, including its name, definition, format, and permitted values.</li>
                                  <li>Flow Charts – illustrate the valid reporting paths for all patient safety concerns, showing the specific data elements and associated answer values required for a complete report.</li>
                                  <li>Annotated Paper Forms – present the complete set of data elements and answer values that can be used to describe a single Patient Safety Event in a question-and-answer format. Note: Forms are currently available only in CFER-Hospital v1.2 and CFER-Diagnostic Safety v1.0.</li>
                                </ul>
                                <p className="mb-1 font-weight-bold">Data Format–Specific Specifications</p>
                                <p className="mb-2">Depending on whether you choose the traditional CDA XML path or the simplified Alternate Data path, you will need the following technical guides:</p>
                                <p className="mb-1 font-weight-bold">For CDA XML Submissions:</p>
                                <ul className="mb-2">
                                  <li>CDA R2 XML Schema Definition: the format structure required for the XML file</li>
                                  <li>Implementation Guide: detailed instructions on how to code the XML to meet PSOPPC standards</li>
                                  <li>Data Submission Error Messages: a guide to troubleshooting and resolving validation issues</li>
                                  <li>CDA XML File Samples: practical examples of correctly formatted files</li>
                                </ul>
                                <p className="mb-1 font-weight-bold">For Alternate Data Submissions (XML or DSV):</p>
                                <ul className="mb-2">
                                  <li>Alternate Format XML Schema Definition: the format structure required for the simplified XML or DSV file</li>
                                  <li>Alternate Data Submission Users Guide: step-by-step instructions for preparing and submitting DSV or simple XML files</li>
                                  <li>Alternate Data Submission File Samples: Example of both compliant XML and DSV (CSV) files.</li>
                                </ul>
                              </>
                            )
                          }
                        },
                        {
                          header: "What should a PSO do if its patient safety data is not in the format that PSOPPC can process directly?  ",
                          content: () => {
                            return (
                              <>
                                <p className="mb-2"><strong>Contact the PSOPPC Help Desk for Personalized Guidance:</strong> We encourage you to reach out to our support team to discuss your specific situation. Our technical experts can often help implement a solution to map and transform your existing data into the AHRQ Common Formats.</p>
                                <p className="mb-2"><strong>Work with a Software Vendor:</strong> You may consider partnering with a PSOPPC software vendor. These vendors are experienced in mapping and transforming non-standardized data into the desired compliant formats.</p>
                                <p className="mb-1"><strong>Success Story:</strong> The PSOPPC recently collaborated with multiple PSOs to successfully map and transform their internal data into a compliant format. We are committed to finding similar technical solutions for your organization.</p>
                              </>
                            )
                          }
                        }
                      ]}
                    ></PublicAccordion>
                
                </Col>
              
              <Col lg="10">
                <h3 className={"mt-5 mb-3 dark-blue header3"}>Data Submission (Website, SFTP, & Web Services)</h3>
                <PublicAccordion
                  defaultActiveKey={[]}
                  accordionItemsContent={[
                    {
                      header: "How can I securely submit my patient safety data to the PSOPPC? ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">The PSOPPC provides two secure methods for transmitting data files. Both methods utilize industry-standard encryption to ensure the privacy and protection of your patient safety information.</p>
                            <p className="mb-1 font-weight-bold">The PSOPPC Secure Website Portal:</p>
                            <p className="mb-1">This is the standard method for manual uploads. It is best suited for PSOs that prefer a hands-on approach or have a lower volume of reports.</p>
                            <ul className="mb-2">
                              <li>Security: Uses encrypted HTTPS transmission (TLS) and requires multi-factor authentication (MFA) for all authorized users</li>
                              <li>Flexibility: Authorized users can manually upload any supported file type, including CDA XML, or PSOPPC-compliant XML and DSV flat files.</li>
                            </ul>
                            <p className="mb-1 font-weight-bold">Secure File Transfer Protocol (SFTP):</p>
                            <p className="mb-1">The SFTP method is designed for PSOs with higher data volumes or those wishing to minimize manual administrative tasks.</p>
                            <ul className="mb-1">
                              <li>Automation: Supports fully automated “machine-to-machine" submissions, requiring no manual intervention once configured.</li>
                              <li>Capacity: Allows for much larger volumes of data than the manual website upload tool.</li>
                              <li>Requirements: Requires an established SFTP account and configuration of Public Key Authentication (PKA)</li>
                            </ul>
                          </>
                        )
                      }
                    },
                    {
                      header: "How do I request an SFTP account?  ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">To request an SFTP account for automated data submission, follow these steps to ensure all security and administrative protocols are met:</p>
                            <p className="mb-1 font-weight-bold">Step 1: Initiate the Request</p>
                            <p className="mb-1">Contact the PSOPPC Help Desk to submit a formal access request.</p>
                            <p className="mb-1">Your request must include:</p>
                            <ul className="mb-2">
                              <li>Your PSO Name</li>
                              <li>Your AHRQ PSO Number (e.g., P0XXXX)</li>
                              <li>Designated Technical Contact(s) who will manage the connection.</li>
                            </ul>
                            <p className="mb-1 font-weight-bold">Step 2: Sign the SOP Agreement</p>
                            <p className="mb-1">Once your request is approved, the Help Desk will provide the SFTP System 	Standard Operating Procedure (SOP) Agreement.</p>
                            <ul className="mb-2">
                              <li>This document must be reviewed and signed by your organization’s Authorized Official.</li>
                              <li>This agreement outlines the technical and security responsibilities for maintaining an automated connection.</li>
                            </ul>
                            <p className="mb-1 font-weight-bold">Step 3: Account Establishment</p>
                            <p className="mb-2">After the signed agreement is returned, the PSOPPC will provide you with the necessary credentials and technical configurations to establish the account,	including instructions for Public Key Authentication (PKA).</p>
                            <p className="mb-1 font-weight-bold">Technical Resource:</p>
                            <p className="mb-1">For a deep dive into the technical requirements for automated transmission, please review the <TextButton variant="comp-link" size="inherit" className="text-start" content="SFTP Data Submission User Manual (PDF)" groupId={SFTPDataSubmissionManualGroupId}
                            //onClick={() => handleFileDownload(SFTPDataSubmissionManualGroupId)}
                            ></TextButton>.</p>
                          </>
                        )
                      }
                    },
                    {
                      header: "How do I know if my file has been successfully submitted to the PSOPPC?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">Successful submission is confirmed in two stages: Receipt (confirmation that the PSOPPC has your file) and Acceptance (confirmation that the file passed validation). The method for checking these results depends on how you submitted the data.</p>
                            <p className="mb-1 font-weight-bold">Website File Upload:</p>
                            <ol className="mb-2">
                              <li>Submission Confirmation: Immediately after uploading, the system displays a confirmation message on the screen.</li>
                              <li>Submission History: You can track the real-time status (e.g., Received, Processing, or Completed) in your account’s submission history.</li>
                              <li>Final Acceptance: Once processing is complete, you must download the Submission Detail Report. A status of “Accepted” with no critical errors indicates the file was successfully processed and stored.</li>
                            </ol>
                            <p className="mb-1 font-weight-bold">Submit Files via SFTP:</p>
                            <ol className="mb-2">
                              <li>Email Acknowledgements: You will receive an initial email acknowledging that the file was received, followed by a second notification once processing is finished.</li>
                              <li>Manual Verification: You can sign in to the PSOPPC website at any time to view the submission status and download the Detail Report to verify results.</li>
                              <li>Automated Verification (Web Service): To fully automate the checking process, you can utilize PSOPPC Web Service APIs. This allows your system to programmatically retrieve processing statuses and validation messages without manual logins.</li>
                            </ol>
                            <p className="mb-1 font-weight-bold">Technical Resources:</p>
                            <ul className="mb-1">
                              <li>Web Service Access: To request a Web Service Account, contact the Help Desk. Review the <TextButton variant="comp-link" size="inherit" className="text-start" content="PSOPPC Web Service Users' Manual (PDF)" 
                                //   onClick={() => handleFileDownload(PSOPPCWebServiceManualGroupId)}
                                groupId={PSOPPCWebServiceManualGroupId}
                              ></TextButton> on how to implement your web service client and invoke the service APIs.</li>
                            </ul>
                          </>
                        )
                      }
                    },
                    {
                      header: "Are my website credentials the same as my SFTP/Web Service credentials?  ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">No. The PSOPPC distinguishes between individual user access and automated organizational accounts.</p>
                            <p className="mb-1 font-weight-bold">Individual User Credentials</p>
                            <p className="mb-1">These credentials are assigned to a specific person. They allow you to sign in to the PSOPPC Website Portal to:</p>
                            <ul className="mb-2">
                              <li>Manually submit patient safety data</li>
                              <li>View and download submission and detail reports</li>
                              <li>Access analytic dashboards and educational resources</li>
                              <li>Manage personal account settings</li>
                            </ul>
                            <p className="mb-1 font-weight-bold">Organizational Service Accounts (SFTP & Web Service)</p>
                            <p className="mb-1">Unlike website logins, these accounts are established for the entire organization (PSO or Vendor) to support automated systems.</p>
                            <ul className="mb-2">
                              <li>SFTP Account: Used exclusively for the secure, automated transmission of patient safety reports. While the account belongs to the organization, designated individual users can be assigned to receive the automated system notifications regarding these submissions.</li>
                              <li>Web Service Account: Used to automate the process of checking submission statuses (Accepted/Rejected) via API. Designated individual users from your organization are granted the authority to reset the Web Service password when necessary.</li>
                            </ul>
                            <p className="mb-1"><strong>Important Note:</strong> Because SFTP and Web Service accounts handle automated data flow, they require a separate setup process. To establish these for your organization, please contact the PSOPPC Help Desk.</p>
                          </>
                        )
                      }
                    }
                  ]}
                ></PublicAccordion>
              
              </Col>
              <Col lg="10">
                <h3 className={"mt-5 mb-3 dark-blue header3"}>Test vs. Production Submissions</h3>
                <PublicAccordion
                  defaultActiveKey={[]}
                  accordionItemsContent={[
                    {
                      header: "What is the purpose of submitting \"Test\" data? How does a Test submission differ from a Production submission?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-1">Submitting data as a Test submission acts as a “dress rehearsal” for your data preparation and submission process. <strong>It allows your PSO to verify file formats, data mapping, and structural integrity without affecting your official reporting record.</strong></p>
                            <p className="mb-0">We strongly encourage PSOs to use the Test environment to resolve all validation errors, ensuring accuracy and compliance before proceeding with a Production submission.</p>
                            <div className="table-wrapper mb-0 mt-0">
                              <table>
                                <tbody>
                                <tr>
                                  <th>Feature</th>
                                  <th>Test Submission</th>
                                  <th>Production Submission</th>
                                </tr>
                                <tr>
                                  <td>Primary Purpose</td>
                                  <td>To validate formatting, mapping, and technical processes.</td>
                                  <td>Official submission of patient safety data.</td>
                                </tr>
                                <tr>
                                  <td>NPSD Transmission</td>
                                  <td>Not transmitted to the National Patient Safety Database (NPSD).</td>
                                  <td>Transmitted to the NPSD for national analysis.</td>
                                </tr>
                                <tr>
                                  <td>Permanent Record</td>
                                  <td>No. Data can be deleted at any time.</td>
                                  <td>Yes. Once submitted, the data becomes part of the permanent record.</td>
                                </tr>
                                <tr>
                                  <td>Deletion</td>
                                  <td>Can and should be deleted after successful validation.</td>
                                  <td>Cannot be deleted once submitted.</td>
                                </tr>
                                <tr>
                                  <td>Storage Limits</td>
                                  <td>The system stores up to 10,000 test reports at a time.</td>
                                  <td>No limit on the number of official production reports.</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </>
                        )
                      }
                    },
                    {
                      header: "Can I delete my submissions?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-1">The ability to delete data depends on whether the submission was marked as Test or Production.</p>
                            <ul className="mb-1">
                              <li><strong>Test Submission:</strong> Yes. Authorized users can delete these at any time via the “Delete Test Submissions” page. Since the system allows for the storage of up to 10,000 test reports, deleting old data after successful validation ensures your test environment remains organized and ready for future validation cycles.</li>
                              <li><strong>Production Submission:</strong> No. Once a file is submitted as Production, it becomes part of the permanent reporting record and is transmitted to the National Patient Safety Database (NPSD). These records cannot be deleted; however, they can be corrected and overwritten if errors are found.</li>
                            </ul>
                          </>
                        )
                      }
                    },
                    {
                      header: "How can I correct my data after it has been accepted as a Production submission? ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-1">If you identify an issue with data that has already been accepted, you can correct the record through a specific resubmission process.</p>
                            <p className="mb-1">To update an existing record:</p>
                            <ol className="mb-2">
                              <li><strong>Match Identifiers:</strong> Use the exact same Provider ID and Event ID as the original submission.</li>
                              <li><strong>Increment Version:</strong> Increase the version number within the report file.</li>
                              <li><strong>Resubmit:</strong> Submit the updated file as a Production submission.</li>
                            </ol>
                            <p className="mb-1">Upon receipt, the system will identify the matching IDs and the higher version number. The new version will overwrite and replace the previously submitted data, ensuring that only the most current and accurate record is retained in the system.</p>
                          </>
                        )
                      }
                    }
                  ]}
                ></PublicAccordion>
              
              </Col>
              <Col lg="10">
                <h3 className={"mt-5 mb-3 dark-blue header3"}>After Data Submission</h3>
                <PublicAccordion
                  defaultActiveKey={[]}
                  accordionItemsContent={[
                    {
                      header: "Are local identifiers removed during the data submission process?  ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">Yes, they are retained temporarily during the initial processing phase to ensure data integrity. The PSOPPC handles local identifiers in two distinct stages:</p>
                            <p className="mb-1"><strong> 1. During Internal Processing</strong></p>
                            <p className="mb-1">Local identifiers (such as Event IDs and Provider IDs) are essential for the system to manage your data. The PSOPPC uses these identifiers to:</p>
                            <ul className="mb-2">
                              <li>Identify and prevent duplicate records</li>
                              <li>Match resubmissions to existing files for the “overwrite/update” process.</li>
                              <li>Provide you with specific feedback in Submission Detail Reports, so you know exactly which records require correction.</li>
                            </ul>
                            <p className="mb-1"><strong>2. Before National Transmission</strong></p>
                            <p className="mb-1">Once processing is complete and the data is prepared for the NPSD, all direct local identifiers are either masked or removed.</p>
                            <p className="mb-1">This ensures that while the data remains useful for longitudinal analysis at the national level, the specific identities associated with the original local records are fully protected and non-identifiable.</p>
                          </>
                        )
                      }
                    },
                    {
                      header: "What happens to my data after it is submitted?  ",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">Protecting the confidentiality of patient safety data is a primary function of the PSOPPC. Once you submit your data, it undergoes a rigorous multi-stage protection process before it is used for national analysis:</p>
                            <ol className="mb-2">
                              <li><strong>De-identification:</strong> The PSOPPC system automatically strips or masks direct identifiers to ensure the data cannot be traced back to a specific patient or provider.</li>
                              <li><strong>Aggregation:</strong> Data is combined with reports from other PSOs across the country.</li>
                              <li><strong>Statistical Disclosure Control (SDC):</strong> The PSOPPC applies advanced SDC techniques to the aggregated data. This process ensures that even in small data sets, “indirect” identifiers cannot be used to re-identify any individual or entity.</li>
                              <li><strong>Transmission to the NPSD:</strong> Only after these security layers are successfully applied is the totally anonymous, high-level data sent to the NPSD for analysis.</li>
                            </ol>
                            <p className="mb-1">For a deeper look at our protection standards, please visit our <Link to={PATHS.public['Data Security']} >Data Security & Privacy</Link> page to learn more.</p>
                          </>
                        )
                      }
                    }
                  ]}
                ></PublicAccordion>
              
              </Col>
              <Col lg="10">
                <h3 className={"mt-5 mb-3 dark-blue header3"}>Data Insights & Analytics</h3>
                <PublicAccordion
                  defaultActiveKey={[]}
                  accordionItemsContent={[
                    {
                      elementId: "data-insights-question-01",
                      header: "What tools are available to help my PSO analyze the data we submit?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-2">The PSOPPC provides several interactive tools to help PSOs move from data collection to meaningful safety insights. These are divided into three main categories:</p>
                            <p className="mb-1"><strong>1. PSO-Specific Clinical Dashboards</strong></p>
                            <p className="mb-1">These interactive dashboards allow you to review only the data your own organization has submitted.</p>
                            <ul className="mb-2">
                              <li>Purpose: They replace traditional tabular reports with user-friendly graphs and filters</li>
                              <li>Functionality: You can manipulate data by event type, harm level, or data range to identify internal trends.</li>
                              <li>Availability: There are over 380 dashboards available across CFER-Hospital Versions 1.2 and 2.0</li>
                            </ul>
                            <p className="mb-1"><strong>2. Comparative National Dashboard (CND)</strong></p>
                            <p className="mb-1">The CND allows you to see how your organization's data compares to the aggregate trends of all other submitting PSOs.</p>
                            <ul className="mb-2">
                              <li>Purpose: It helps you understand if your observed patient safety concerns are consistent with national trends or if there are unique opportunities for improvement.</li>
                              <li>Privacy: All data is color-coded and aggregated to ensure that other PSOs remain non-identifiable.</li>
                            </ul>
                            <p className="mb-1"><strong>3. NPSD Public Dashboards</strong></p>
                            <ul className="mb-2">
                              <li>Focus: These dashboards explore common patient safety concerns (like Falls, Medication events, or Pressure Ulcers) across the entire country.</li>
                              <li>Updates: The NPSD is updated annually (e.g., the revised Medication or Other Substances Dashboard released in 2024) to reflect the most current national safety climate.</li>
                              <li>External Access: You can explore these national data sets directly on the AHRQ website via the NPSD Interactive Data Dashboards.</li>
                            </ul>
                          </>
                        )
                      }
                    },
                    {
                      header: "Where can I find the PSOPPC dashboards as a submitting PSO?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-1">Access to your data insights is a simple process through the secure portal.</p>
                            <ol className="mb-2">
                              <li><strong>Log in</strong> to the PSOPPC website with your Level 3 credentials.</li>
                              <li>Navigate to the “<strong>Analytical Dashboard</strong>” option on the left-hand menu.</li>
                              <li>Select either “<strong>Clinical Reports</strong>” (for your internal data) or “<strong>Comparative National Dashboards</strong>” (for national benchmarking).</li>
                            </ol>
                            <p className="mb-1"><strong>Technical Resources:</strong></p>
                            <ul className="mb-1">
                              <li><TextButton variant={"comp-link"} size={"inherit"} className="text-start" content={"Issue 46 - PSO Specific Clinical Dashboards (PDF)"} groupId={IssuePSOSpecificClinicalDashboardsGroupId}
                            //   onClick={() => handleFileDownload(IssuePSOSpecificClinicalDashboardsGroupId)}
                              ></TextButton></li>
                              <li><TextButton groupId={IssueComparativeNationalDashboard} variant={"comp-link"} size={"inherit"} className="text-start" content={"Issue 60 - Comparative National Dashboard Innovations (PDF)"}
                            //   onClick={() => handleFileDownload(IssueComparativeNationalDashboard)}
                              ></TextButton></li>
                            </ul>
                          </>
                        )
                      }
                    }
                  ]}
                ></PublicAccordion>
              
              </Col>
              <Col lg="10">
                <h3 className={"mt-5 mb-3 dark-blue header3"}>Still Have Questions?</h3>
                <PublicAccordion
                  defaultActiveKey={[]}
                  accordionItemsContent={[
                    {
                      header: "How do I contact the PSOPPC Help Desk for questions or issues regarding data submission?",
                      content: () => {
                        return (
                          <>
                            <p className="mb-1">Yes. The Help Desk is available Monday through Friday, 9:00 a.m. to 5:30 p.m. ET.</p>
                            <ul className="mb-1">
                              <li><strong>Email: </strong><a href="mailto:support@psoppc.org" tabIndex={0}>support@psoppc.org</a></li>
                              <li><strong>Phone: </strong><a href="tel:+18665717712" tabIndex={0}>(866) 571-7712</a></li>
                            </ul>
                          </>
                        )
                      }
                    }
                  ]}
                ></PublicAccordion>
              
              </Col>
            
            </Row>

            <DidFindPrompt></DidFindPrompt>

            <Feedback/>

            <NextPage path={PATHS.public['Learn from the Data']} text="Learn from the Data"
                backPath={PATHS.public['Current Common Formats']} backPathText="Current Common Formats"
            ></NextPage>
            
            </ReCaptchaWrapper>
        </>
    );
}

export default DataSubmission;